import CatalogTransferWizardHeader from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferWizard/CatalogTransferWizardHeader'
import React from 'react'

const UploadDocumentStepHeader = () => (
    <CatalogTransferWizardHeader title="Upload Required Documentation">
        <div className="ct-import-step-header-copy">
            <p>Please upload your Letter of Authorization (LOA) below.</p>
            <div className="self-admin-note">
                <strong>Note for Self-Administered Songwriters:</strong>
                <br />
                If you are a self-administered songwriter receiving rights from a publisher or publishing administrator:
                <ul>
                    <li>
                        You <strong>do NOT need to submit a Letter of Authorization (LOA)</strong> because you are
                        effectively administering your own rights.
                    </li>
                    <li>
                        However, you <strong>should upload a Letter of Relinquishment (LOR)</strong> from the previous
                        member entitled to administer the works.
                    </li>
                </ul>
            </div>
            <p>
                To learn more about required documentation, visit our{' '}
                <a
                    href="https://help.themlc.com/en/support/catalog-transfer-process-and-faqs"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Help Center
                </a>{' '}
                article.
            </p>
        </div>
    </CatalogTransferWizardHeader>
)

export default UploadDocumentStepHeader
